import { motion } from "framer-motion";
import { useGameStore } from "../store";
import { Trophy, Users } from "lucide-react";

export function PlayerList() {
  const { players, finalPlayers, gameStarted } = useGameStore();

  // finalPlayers est le classement figé à l'arrivée : une fois la course finie,
  // la liste ne bouge plus même si des joueurs se déconnectent.
  const roster = finalPlayers ?? players;

  // Trier par score décroissant pendant la partie
  const sorted = gameStarted
    ? [...roster].sort((a, b) => b.score - a.score)
    : roster;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`
        ${
          gameStarted
            ? "fixed bottom-4 right-4 max-w-xs"
            : "w-full max-w-md mx-auto mt-4"
        }
        z-50 bg-white/80 backdrop-blur-xl p-4 rounded-blob shadow-kawaii-lg border-2 border-sakura-200/50
      `}
    >
      <div className="flex items-center gap-2 mb-3">
        {gameStarted ? (
          <Trophy className="w-4 h-4 text-star" />
        ) : (
          <Users className="w-4 h-4 text-sakura-400" />
        )}
        <h3 className="text-sm font-black text-sakura-500">
          {gameStarted ? "Leaderboard" : `Players (${players.length})`}
        </h3>
      </div>

      {players.length === 0 ? (
        <p className="text-lavender-400 text-center py-3 text-xs font-bold">
          Waiting for players...
        </p>
      ) : (
        <div className="space-y-1.5">
          {sorted.map((player, index) => (
            <motion.div
              key={player.id}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.05 }}
              className={`flex items-center justify-between px-3 py-2 rounded-xl transition-colors ${
                gameStarted && index === 0
                  ? "bg-gradient-to-r from-star/20 to-sakura-100 border border-star/30"
                  : "bg-sakura-50/60 border border-sakura-100/50"
              }`}
            >
              <div className="flex items-center gap-2 min-w-0">
                {gameStarted && (
                  <span className={`text-xs font-black shrink-0 w-5 h-5 rounded-full flex items-center justify-center ${
                    index === 0 ? "bg-star text-white" : "bg-lavender-200 text-lavender-500"
                  }`}>
                    {index + 1}
                  </span>
                )}
                <span className="font-bold text-gray-700 text-sm truncate">
                  {player.name}
                </span>
              </div>
              <div className="shrink-0 ml-2">
                {!gameStarted && (
                  <span className={`text-xs font-black px-2 py-0.5 rounded-full ${
                    player.ready
                      ? "bg-emerald-100 text-emerald-600"
                      : "bg-lavender-100 text-lavender-400"
                  }`}>
                    {player.ready ? "Ready" : "Waiting"}
                  </span>
                )}
                {gameStarted && (
                  <span className="text-sm font-black text-sakura-500">
                    {player.score.toLocaleString()}
                  </span>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </motion.div>
  );
}
